import * as React from "react"
import { FunctionComponent, useState } from "react"
import { CartStructure, Product, ShippingMethod } from "../../interfaces/SaleorTypes"
import styled from "styled-components"
import CheckoutSummary from "../../store/checkout/CheckoutSummary"
import CheckoutJourney from "../../store/checkout/CheckoutJourney"
import { HorizontalSpacer } from "../../atoms/spacers"
import { Col, Container, Row, Visible } from "react-grid-system"
import Card from "../../atoms/Card"
import H1 from "../../atoms/typography/H1"
import { CartSolutionOrder } from "../../../utils/models"
interface CheckoutPageProps {
  cart: CartStructure[]
  removeFromCart: (products: CartStructure[]) => void
  addToCart: (products: CartStructure[]) => void
  updateItemInCart: (item: Product) => void
  onClearCart: () => void
  solutions: CartSolutionOrder[]
}

const CheckoutPageWrapper = styled.div`
  background-color: #f5f5f5;
`

const CheckoutPage: FunctionComponent<CheckoutPageProps> = ({
  cart,
  addToCart,
  onClearCart,
  removeFromCart,
  updateItemInCart,
  solutions,
  ...props
}) => {
  const [selectedShipping, setSelectedShipping] = useState<ShippingMethod>()
  const [isSummaryLocked, setIsSummaryLocked] = useState<boolean>(false)
  const [isDirectPayment, setIsDirectPayment] = useState<boolean>(true)
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [initialView, setInitialView] = useState<string>()

  const onLockSummary = (flag: boolean) => {
    setIsSummaryLocked(flag)
  }

  const onDirectPayment = (flag: boolean) => {
    setIsDirectPayment(flag)
  }

  const onShippingMethodClick = (method: ShippingMethod) => {
    setSelectedShipping(method)
  }

  const setModal = (flag: boolean, view?: string) => {
    setOpenModal(flag)
    view && setInitialView(view)
  }

  return (
    <CheckoutPageWrapper>
      <HorizontalSpacer spacing={4} />
      <Container>
        <Row>
          <Col md={7}>
            <Card>
              <div style={{ padding: "1rem" }}>
                {cart.length > 0 && (
                  <CheckoutJourney
                    onClearCart={onClearCart}
                    onSetModal={setModal}
                    cart={cart}
                    onDirectPayment={onDirectPayment}
                    onLockSummary={onLockSummary}
                    onPassShippingMethod={onShippingMethodClick}
                  />
                )}
              </div>
            </Card>
          </Col>
          <Col md={5}>
            <Visible xs>
              <HorizontalSpacer spacing={4} />
            </Visible>
            <Card>
              <H1>Summary</H1>
              <HorizontalSpacer spacing={2} />
              <CheckoutSummary
                onSetModal={setModal}
                cart={cart}
                isDirectPayment={isDirectPayment}
                isSummaryLocked={isSummaryLocked}
                shippingMethod={selectedShipping}
                addToCart={addToCart}
                removeFromCart={removeFromCart}
                updateItemInCart={updateItemInCart}
                solutions={solutions}
              />
            </Card>
          </Col>
        </Row>
      </Container>

      <HorizontalSpacer spacing={8} />
    </CheckoutPageWrapper>
  )
}

export default CheckoutPage
